import OrdersTableItem from './OrdersTableItem';
import { connect } from 'react-redux';
import {
  ordersActions,
  ordersTrackingNumberSel
} from 'src/store/modules/orders';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: any) => {
  return {
    trackingNumbers: ordersTrackingNumberSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getTrackingNumbers: (
    lineNumber: number,
    orderDate: number,
    orderNumber: number,
    orderDetailStatus: string
  ) =>
    dispatch(
      ordersActions.getTracking(
        lineNumber,
        orderDate,
        orderNumber,
        orderDetailStatus
      )
    )
});

export const pureComponent = OrdersTableItem;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(OrdersTableItem));

interface IDispatchFromProps {
  getTrackingNumbers(
    lineNumber: number,
    orderDate: number,
    orderNumber: number,
    orderDetailStatus: string
  ): void;
}
